import React, { useState } from "react";
import { Form, Icon } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const getBeginningOfSchoolYear = () => {
  let retVal = new Date();
  if (retVal.getMonth() < 7) {
    retVal.setFullYear(retVal.getFullYear() - 1);
  }
  retVal.setMonth(7);
  retVal.setDate(1);
  return moment(retVal).startOf("day");
};

const ReportRangeForm = ({ onSubmit }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [startDate, setStartDate] = useState(getBeginningOfSchoolYear());
  const [endDate, setEndDate] = useState(moment().endOf("day"));
  const [showComments, setShowComments] = useState(true);
  const [showUnsentReports, setShowUnsentReports] = useState(false);

  return (
    <Form
      onSubmit={async () => {
        setIsSaving(true);
        const args = {
          startDate: startDate.format("YYYY-MM-DDZ"),
          endDate: moment(endDate).add(1, "day").format("YYYY-MM-DDZ"),
          showComments,
          showUnsentReports,
        };
        console.log(args);
        await onSubmit(args);
        setIsSaving(false);
      }}
    >
      <Form.Field>
        <label>Start Date</label>
        <DatePicker
          selected={new Date(startDate)}
          onChange={(d) => setStartDate(moment(d))}
        />
      </Form.Field>
      <Form.Field>
        <label>End Date</label>
        <DatePicker
          selected={new Date(endDate)}
          onChange={(d) => setEndDate(moment(d))}
        />
      </Form.Field>
      <Form.Checkbox
        label="Include Unsent Reports"
        checked={showUnsentReports}
        onChange={() => setShowUnsentReports(!showUnsentReports)}
      />
      <Form.Checkbox
        label="Show Comments"
        checked={showComments}
        onChange={() => setShowComments(!showComments)}
      />
      <Form.Button
        floated="right"
        loading={isSaving}
        disabled={endDate < startDate}
      >
        <Icon name="print" /> Print
      </Form.Button>
    </Form>
  );
};

export default ReportRangeForm;
